/**
 * JSBridge 调用文档
 *
 * 1. 跳转到原生登录页
 * callHandler({
 *   uri: 'request',
 *   method: 'nativeGoLogin'
 * })
 *
 * 2. 控制原生导航栏显示/隐藏
 * callHandler({
 *   uri: 'request',
 *   method: 'configNativeNavigationBar',
 *   data: {
 *     hide: true  // true: 隐藏, false: 显示
 *   }
 * })
 *
 * 3. 跳转充值页面
 * callHandler({
 *   uri: 'request',
 *   method: 'nativeGoCharge',
 *   data: {
 *     currency: ''  // 币种
 *   }
 * })
 *
 * 4. 跳转合约交易页面
 * callHandler({
 *   uri: 'request',
 *   method: 'nativeFutures',
 *   data: {
 *     contractId: null  // 合约ID
 *   }
 * })
 *
 * 5. 跳转订单页面
 * callHandler({
 *   uri: 'request',
 *   method: 'nativeGoFinanceOrderList'
 * })
 *
 * 6. 返回上一页
 * callHandler({
 *   uri: 'request',
 *   method: 'nativeGoBack'
 * })
 */

export const isAndroid = typeof window !== 'undefined' && (navigator.userAgent.includes('Android') || navigator.userAgent.includes('Adr') || navigator.userAgent.includes('tuling'))

export const isiOS = typeof window !== 'undefined' && !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

function setupWebViewJavascriptBridge(callback) {
  const bridgePromise = new Promise((resolve) => {
    if (isAndroid) {
      if (window.WebViewJavascriptBridge) {
        resolve(window.WebViewJavascriptBridge)
      }
      else {
        document.addEventListener(
          'WebViewJavascriptBridgeReady',
          () => {
            resolve(window.WebViewJavascriptBridge)
          },
          false,
        )
      }
    }
    else if (isiOS) {
      if (window.WebViewJavascriptBridge) {
        return resolve(window.WebViewJavascriptBridge)
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(resolve)
      }
      window.WVJBCallbacks = [resolve]
      const WVJBIframe = document.createElement('iframe')
      WVJBIframe.style.display = 'none'
      WVJBIframe.src = 'https://__bridge_loaded__'
      document.documentElement.appendChild(WVJBIframe)
      setTimeout(() => {
        document.documentElement.removeChild(WVJBIframe)
      }, 100)
    }
  })

  // 兼容回调方式
  callback && bridgePromise.then(callback)

  return bridgePromise
}

setupWebViewJavascriptBridge().then((bridge) => {
  if (isAndroid) {
    bridge.init((message, responseCallback) => {
      const data = {
        'Javascript Responds': '测试中文!',
      }
      responseCallback && responseCallback(data)
    })
  }
})

// 初始化jsbridge
function registerHandler(funName, dataJson, callback) {
  return new Promise((resolve) => {
    setupWebViewJavascriptBridge().then((bridge) => {
      bridge.registerHandler(funName, (data, responseCallback) => {
        responseCallback(dataJson)
        callback && callback(data)
        resolve(data)
      })
    })
  })
}

// 支持promise
function callHandler(msg) {
  return new Promise((resolve, reject) => {
    try {
      if (msg.success) {
        const callbackName = msg.success
        window[callbackName] = (result) => {
          delete window[callbackName]
          resolve(result)
        }
      }
      if (isiOS) {
        window.webkit.messageHandlers.JShandle.postMessage(JSON.stringify(msg))
        !msg.success && resolve()
      }
      else if (isAndroid) {
        // eslint-disable-next-line no-alert
        const result = window.prompt(JSON.stringify(msg))
        !msg.success && resolve(result)
      }
    }
    catch (error) {
      reject(error)
    }
  })
}

function oldCallHandler(msg) {
  if (isiOS) {
    window.webkit.messageHandlers.JShandle.postMessage(JSON.stringify(msg))
  }
  else if (isAndroid) {
    window.prompt(JSON.stringify(msg))
  }
}

export function nativeGoLogin() {
  return callHandler({
    uri: 'request',
    method: 'nativeGoLogin',
  })
}

export function nativeGoBack() {
  return callHandler({
    uri: 'request',
    method: 'nativeGoBack',
  })
}

export { callHandler, registerHandler, oldCallHandler}
